module.exports = __webpack_public_path__ + "static/media/ORISHA_LOGOTYPE_GROUPE_EXECUTE_POSITIF_RVB.a600976e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/ORISHA_LOGOTYPE_GROUPE_EXECUTE_POSITIF_RVB.png
// module id = 1024
// module chunks = 0